import { useEffect, useRef, useState } from "react";

import { getClients } from "services/clients/rest";
import { ClientListDto } from "services/clients/restModels";

import { CLIENTS_PAGE_SIZE } from "features/Clients/constants";

export interface ClientsState {
    clients: ClientListDto[];
    total: number;
    page: number;
    pageSize: number;
    loading: boolean;
    error: boolean;
    setPage: (page: number) => void;
}

export const useClientsState = (): ClientsState => {
    const [clients, setClients] = useState<ClientListDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [page, setPage] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    // Номер актуальной выборки: ответ по прошлой странице отбрасываем, иначе медленный
    // запрос дорисовался бы поверх уже открытой другой страницы.
    const scopeRef = useRef<number>(0);

    useEffect(() => {
        const scope = scopeRef.current + 1;
        scopeRef.current = scope;

        setLoading(true);
        setError(false);

        getClients((page - 1) * CLIENTS_PAGE_SIZE, CLIENTS_PAGE_SIZE)
            .then((result) => {
                if (scopeRef.current !== scope) return;

                if (!result) {
                    setError(true);
                    setClients([]);
                    setTotal(0);
                    return;
                }

                setClients(result.items);
                setTotal(result.total);
            })
            .catch(() => {
                if (scopeRef.current !== scope) return;
                setError(true);
                setClients([]);
                setTotal(0);
            })
            .finally(() => {
                if (scopeRef.current !== scope) return;
                setLoading(false);
            });
    }, [page]);

    return { clients, total, page, pageSize: CLIENTS_PAGE_SIZE, loading, error, setPage };
};
